import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  CmFlex,
  CmIconButton,
  CmText,
} from '@/components/uiParts';

type TablePaginationProps = {
  currentPage: number;
  itemsPerPage: number;
  totalItems: number;
  onPageChange: (page: number) => void;
};

export const TablePagination: React.FC<TablePaginationProps> = ({
  currentPage,
  itemsPerPage,
  totalItems,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  return (
    <CmFlex alignItems="center">
      <CmIconButton
        aria-label="First page"
        icon={<ArrowLeftIcon />}
        size="sm"
        mr={1}
        onClick={() => onPageChange(1)}
        isDisabled={currentPage === 1}
        bg="gray.100"
        _hover={{ bg: 'gray.200' }}
      />
      <CmIconButton
        aria-label="Previous page"
        icon={<ChevronLeftIcon boxSize={6} />}
        size="sm"
        mr={2}
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        isDisabled={currentPage === 1}
        bg="gray.100"
        _hover={{ bg: 'gray.200' }}
      />

      <CmText mx={2} fontWeight="medium">
        {`${(currentPage - 1) * itemsPerPage + 1}~${Math.min(
          currentPage * itemsPerPage,
          totalItems
        )} / ${totalItems}`}
      </CmText>

      <CmIconButton
        aria-label="Next page"
        icon={<ChevronRightIcon boxSize={6} />}
        size="sm"
        ml={2}
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        isDisabled={currentPage === totalPages}
        bg="gray.100"
        _hover={{ bg: 'gray.200' }}
      />
      <CmIconButton
        aria-label="Last page"
        icon={<ArrowRightIcon />}
        size="sm"
        ml={1}
        onClick={() => onPageChange(totalPages)}
        isDisabled={currentPage === totalPages}
        bg="gray.100"
        _hover={{ bg: 'gray.200' }}
      />
    </CmFlex>
  );
};
